/**
 * AuthorFollowMoreLink — small "More from @<handle> →" pill placed
 * next to the ClapButton at the end of every article. Resolves the
 * writer's SocialPulse handle so the link lands on their profile
 * page (`/{handle}?tab=articles`) instead of the legacy id URL.
 */
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const BASE = `${process.env.REACT_APP_BACKEND_URL || ""}/api/publisher/v1`;

export default function AuthorFollowMoreLink({ authorId }) {
  const [author, setAuthor] = useState(null);
  useEffect(() => {
    if (!authorId) return;
    let alive = true;
    fetch(`${BASE}/authors/${authorId}/card`)
      .then((r) => r.ok ? r.json() : null)
      .then((d) => { if (alive && d) setAuthor(d.author); })
      .catch(() => {});
    return () => { alive = false; };
  }, [authorId]);
  if (!authorId) return null;

  const label = author?.handle
    ? `@${author.handle}`
    : (author?.name || (authorId.length > 12 ? authorId.slice(0, 12) + "…" : authorId));
  const href = author?.handle
    ? `/${author.handle}?tab=articles`
    : `/publisher/author/${authorId}`;

  return (
    <Link
      to={href}
      className="text-xs text-slate-500 hover:text-blue-700 font-semibold"
      data-testid="publisher-article-view-author-link"
    >
      More from {label} →
    </Link>
  );
}
